import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toastManagerInstance, SimpleToast } from '@exchange/libs/toasts/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'XCopyTextbox',
  props: {
  onError: { type: Function, default: () => {} },
  onSuccess: { type: Function, default: () => {} },
  successToastMessage: { type: [String, Number], required: true },
},
  setup(__props) {

const props = __props;

const doOnSuccess = () => {
  props.onSuccess?.();
  toastManagerInstance.addToast({
    content: SimpleToast,
    props: {
      variant: 'default',
      title: 'fundamentals.copy.title',
      translatedMessage: props.successToastMessage,
    },
  });
};

const doOnError = () => {
  props.onError?.();
  toastManagerInstance.addToast({
    content: SimpleToast,
    props: {
      variant: 'failed',
      title: 'fundamentals.copy.title',
      message: 'fundamentals.copy.failed',
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_ot_copy_textbox = _resolveComponent("ot-copy-textbox")!

  return (_openBlock(), _createBlock(_component_ot_copy_textbox, _mergeProps(_ctx.$attrs, {
    "on-error": doOnError,
    "on-success": doOnSuccess,
    class: "x-copy-textbox"
  }), null, 16))
}
}

})